<template>
  <Container type="card-full">
    <!-- <div slot="header"> -->
      <!-- <el-button @click="addCarfig" :loading="btnLoading">新增</el-button> -->
      <!-- <el-button @click="chgCarfig" :loading="btnLoading">修改</el-button>
      <el-button @click="delCarfig" :loading="btnLoading">删除</el-button>
      <el-button @click="close">关闭</el-button> -->
    <!-- </div> -->
    <vggrid :list="list" tableheight="600" flexname=""
    :cols="cols" :showfooter="false" :showPage="true"
    :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
            :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick">
        <template slot="btn">
           <vxe-button icon="vxe-icon--plus" status="perfect" @click="addCarfig" :loading="btnLoading">新增</vxe-button>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'carfigIndex',
    data () {
      return {
        wmenu: this.$route.params.form,
        list: [],
        btnLoading: false,
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'wmenuname', fieldtype: 'C', title: '菜单',calculExpr:'', addNewRowFlg: false},
          { field: 'carfigname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false},
          { field: 'carfigseq', fieldtype: 'N', title: '轮播顺序',calculExpr:'',addNewRowFlg: false},
          { field: 'carfigurl', fieldtype: 'C', title: 'URL',calculExpr:'',addNewRowFlg: false},
          // { field: 'carfigstatus', fieldtype: 'B', title: '状态',calculExpr:'',addNewRowFlg: false}
        ],
        carfig: {},
        isOperate:true,
        operateBtn:[
          {btncode:'CHG',btnicon:'el-icon-edit-outline',btnname:'修改'},
          {btncode:'DEL',btnicon:'el-icon-delete',btnname:'删除'}
        ],
        query: {
          wmenuid: this.$route.params.form.wmenuid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('CHG', () => this.chgCarfig())
      this.$on('DEL', () => this.delCarfig())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async init() {
        this.wmenu = this.$route.params.form
        this.query = {
          wmenuid: this.$route.params.form.wmenuid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.carfig = {}
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'womIndex'})
      },
      vggridClick(code,row){
        this.carfig = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async addCarfig () {
        let form = {
          carfigid: 0,
          carfigwmenuid: this.wmenu.wmenuid,
          wmenu: this.wmenu
        }
        this.$router.push({name: 'carfigForm', params: {form: form, type: 1}})
      },
      async chgCarfig () {
        this.carfig.wmenu = this.wmenu
        this.$router.push({name: 'carfigForm', params: {form: this.carfig, type: 2}})
      },
      async delCarfig () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/ywgl/carfig/delCarfig',
            method: "post",
            data: this.carfig
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async cellClick (row) {
        this.carfig = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/carfig/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
